import me    from './auth/me'
import token from './auth/token'

const auth =
{
    me,
    token
};

export default auth ;